import { render, staticRenderFns } from "./ProfilePersonalInfo.vue?vue&type=template&id=2d06f156&scoped=true&"
import script from "./ProfilePersonalInfo.vue?vue&type=script&lang=ts&"
export * from "./ProfilePersonalInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ProfilePersonalInfo.vue?vue&type=style&index=0&id=2d06f156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d06f156",
  null
  
)

export default component.exports